module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "paypal-button"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c497080","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booker/PayPalCheckout.vue
// module id = 870
// module chunks = 2